import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";

import { CitizenOTPContext } from "components/citizen-otp/CitizenOTPContext";
import { Button } from "primereact/button";

export const CitizenOTPEditor = () => {
    const toast = useRef(null);
    const { t } = useTranslation(["send-otp", "common"]);

    const sendOTPContext = useContext(CitizenOTPContext);
    const { sendOTP, setSendOTP, sendOTPDialog, setSendOTPDialog } = sendOTPContext;

    const states = [
        { label: t("registering"), value: "REGISTERING" },
        { label: t("otp.verified"), value: "OTP_VERIFIED" },
        { label: t("expired"), value: "EXPIRED" },
        { label: t("completed"), value: "COMPLETED" },
    ];

    const types = [
        { label: t("account.register"), value: "ACCOUNT_REGISTER" },
        { label: t("reset.password"), value: "RESET_PASSWORD" },
        { label: t("active.device"), value: "ACTIVE_DEVICE" },
        { label: t("other.device"), value: "OTHER_DEVICE" },
        { label: t("change.phone.number"), value: "CHANGE_PHONE_NUMBER" },
        { label: t("Cập nhật thông tin tài khoản covid"), value: "VERIFY_INFORMATION" },
        { label: t("Thiết lập lại passcode"), value: "RESET_PASSCODE" },
        { label: t("Đăng nhập trên web"), value: "WEB_LOGIN" },
        { label: t("Đổi mật khẩu khi đến hạn"), value: "CHANGE_PASSWORD_EXPIRED" },
        { label: t("Kích hoạt lại thiết bị"), value: "REACTIVE_DEVICE" },
    ];

    const methods = [
        { label: "OTP SMS", value: "SMS" },
        { label: "OTP email", value: "EMAIL" },
        { label: "OTP thiết bị", value: "DEVICE" },
    ];

    const hideDialog = () => {
        setSendOTPDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={sendOTPDialog} style={{ width: "60%" }} header={t("sendOTP.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* số CCCD */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="idNumber">{t("idNumber")}</label>
                                    <InputText id="idNumber" value={sendOTP?.idNumber} readOnly />
                                </div>
                                {/* số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="phoneNumber">{t("phoneNumber")}</label>
                                    <InputText id="phoneNumber" value={sendOTP?.phoneNumber} readOnly />
                                </div>
                                {/* loại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="type">{t("type")}</label>
                                    <InputText id="type" value={types.find((g) => g.value === sendOTP?.type)?.label} readOnly />
                                </div>
                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="state">{t("state")}</label>
                                    <InputText id="state" value={states.find((g) => g.value === sendOTP?.state)?.label} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* ngày hết hạn */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="expiredDate">{t("expiredDate")}</label>
                                    <InputText id="expiredDate" value={sendOTP?.expiredDate} readOnly />
                                </div>
                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate", { ns: "common" })}</label>
                                    <InputText id="createdDate" value={sendOTP?.createdDate} readOnly />
                                </div>
                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={sendOTP?.modifiedDate} readOnly />
                                </div>

                                <div className="field col-12 md:col-2">
                                    <label htmlFor="method">{t("sendOTP.method")}</label>
                                    <InputText id="method" name="method" value={methods.find((e) => e.value === sendOTP?.method)?.label} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
